module.exports = "https://bper-network.servercdn.it/static/img/FuturaPT-Book.svg?65146be05124f345c830962e442b047d";